/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Insight_TitleInputs */

const en_us2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer`)
};

const pt_br2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal`)
};

const es_419_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador`)
};

const pt_pt2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador`)
};

const fr_fr2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach`)
};

const de_de2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach`)
};

const it_it2_today_insight_title = /** @type {(inputs: Today_Insight_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach`)
};

/**
* | output |
* | --- |
* | "Your trainer" |
*
* @param {Today_Insight_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_insight_title = /** @type {((inputs?: Today_Insight_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Insight_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_insight_title(inputs)
	if (locale === "es-419") return es_419_today_insight_title(inputs)
	if (locale === "pt-PT") return pt_pt2_today_insight_title(inputs)
	if (locale === "fr-FR") return fr_fr2_today_insight_title(inputs)
	if (locale === "de-DE") return de_de2_today_insight_title(inputs)
	if (locale === "it-IT") return it_it2_today_insight_title(inputs)
	return en_us2_today_insight_title(inputs)
});
export { today_insight_title as "today.insight_title" }